<template>
  <div>
    <h2 class="title is-4">Coil</h2>
    <div class="columns">
      <div class="column is-3">
        <h3 class="title is-5">
          Frequency
          <font-awesome-icon
            icon="info-circle"
            title="The Larmor frequency depends on the MRI static field strength, and it is equal to 64 MHz for a 1.5 T MRI system and to 128 MHz for a 3 T MRI system.  "
            style="cursor: help;"
          />
        </h3>
        <div class="field">
          <div class="control">
            <div v-for="(opt) in frequencies" :key="opt.id">
              <label class="radio my-extra-spacing">
                <input
                  type="radio"
                  class="my-extra-spacing"
                  name="Frequency"
                  v-bind:value="opt.id"
                  v-bind:checked="frequency==opt.id"
                  v-on:change="onFrequency"
                  v-bind:id="'step3-frequency-' + opt.val"
                />
                {{opt.label}}
              </label>
              <br />
            </div>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <h3 class="title is-5">
          Power
          <font-awesome-icon
            icon="info-circle"
            title="RF coil input power was calculated based on the phantom level of exposure (whole body SAR). Based on the IEC 60601-2-33 the modes are identified as: Normal (2 W/kg), 1st Level Controlled (4 W/kg), 2nd Level Controlled (>4 W/kg)"
            style="cursor: help;"
          />
        </h3>
        <div class="field">
          <div class="control">
            <div v-for="(opt) in powers" :key="opt.id">
              <label class="radio my-extra-spacing">
                <input
                  type="radio"
                  class="my-extra-spacing"
                  name="Power"
                  v-bind:value="opt.id"
                  v-bind:checked="power==opt.id"
                  v-on:change="onPower"
                  v-bind:id="'step3-power-' + opt.val"
                />
                {{opt.label}}
              </label>
              <br />
            </div>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <h3 class="title is-5">
          Polarization
          <font-awesome-icon
            icon="info-circle"
            title="The circular polarization is obtained by feeding the coil with two feeds geometrically located 90° apart. The two polarizations are achieved changing the sign of the relative phases of the two RF sources (i.e., Circular1 = {Φ(F1) = 90°, Φ(F2) = 0°} and Circular2 = {Φ(F1) = 0°, Φ(F2) = 90°}). Conversely the linear polarizations are obtained feeding the coil with only one of the two feeds (i.e., one for each configuration)."
            style="cursor: help;"
          />
        </h3>
        <div class="field">
          <div class="control">
            <div v-for="(opt) in polarizations" :key="opt.id">
              <label class="radio my-extra-spacing">
                <input
                  type="radio"
                  class="my-extra-spacing"
                  name="Polarization"
                  v-bind:value="opt.id"
                  v-bind:checked="polarization==opt.id"
                  v-on:change="onPolarization"
                  v-bind:id="'step3-polarization-' + opt.val"
                />
                {{opt.label}}
              </label>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      frequency: 0,
      power: 0,
      polarization: 0,
      frequencies: [
        { id: 0, label: '64 MHz', val: '64' },
        { id: 1, label: '128 MHz', val: '128' },
      ],
      powers: [
        { id: 0, label: '2 W/kg', val: '2' },
        { id: 1, label: '4 W/kg', val: '4' },
        { id: 2, label: '10 W/kg', val: '10' },
      ],
      polarizations: [
        { id: 0, label: 'Circular 1', val: 'CP1' },
        { id: 1, label: 'Circular 2', val: 'CP2' },
        { id: 2, label: 'Linear 1', val: 'LP1' },
        { id: 3, label: 'Linear 2', val: 'LP2' },
      ],
    };
  },
  methods: {
    onFrequency(event) {
      this.frequency = event.target.value;
      this.$emit('onFrequency', this.frequency);
    },
    onPower(event) {
      this.power = event.target.value;
      this.$emit('onPower', this.power);
    },
    onPolarization(event) {
      this.polarization = event.target.value;
      this.$emit('onPolarization', this.polarization);
    },
  },
};
</script>

<style scoped>
label.my-extra-spacing {
  margin-bottom: 0.5em;
}
input.my-extra-spacing {
  margin-right: 0.5em;
}
</style>
